import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

/**
 * Query defaults.
 *
 * `staleTime` is deliberately short and uniform: this UI never claims data is
 * current on its own authority. Every screen shows the freshness the server
 * reports for each source clock (spec section 64), so client-side caching
 * cannot make anything look fresher than it is.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry(failureCount, error) {
          // Auth, permission, contract and missing-route failures will not fix
          // themselves; retrying only delays the error the operator needs.
          if (error instanceof ApiError) {
            if (['UNAUTHENTICATED', 'FORBIDDEN', 'NOT_FOUND', 'CONTRACT_MISMATCH'].includes(error.kind)) {
              return false;
            }
            if (error.isMissingRoute) return false;
          }
          return failureCount < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}
